import { BUSINESS_OFFERS, INSURANCE_OFFERS, ACTIONS, COMMON_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';

const SPECIAL_TAB_TO_TITLE_MAP = {
    [COMMON_OFFERS.savings]: 'по вкладам',
    [COMMON_OFFERS.credits]: 'по кредитам',
    [COMMON_OFFERS.debitCards]: 'по дебетовым картам',
    [COMMON_OFFERS.creditCards]: 'по кредитным картам',
    [COMMON_OFFERS.mortgage]: 'по ипотеке',
    [COMMON_OFFERS.loan]: 'по займам',
    [COMMON_OFFERS.accumulative]: 'по накопительным счетам',
    [COMMON_OFFERS.brokerskoeObsluzhivanie]: 'по брокерскому обслуживанию',
    [COMMON_OFFERS.bankrotstvo]: 'по банкротству физических лиц',
    [ACTIONS.osago]: 'по ОСАГО',
    [INSURANCE_OFFERS.insuranceOsago]: 'по страхованию ОСАГО',
    [INSURANCE_OFFERS.dms]: 'по добровольному медицинскому страхованию',
    [INSURANCE_OFFERS['strahovanie-domov']]: 'по страхованию дома и дачи',
    [INSURANCE_OFFERS['strahovka-kriticheskie-bolezni']]: 'по страхованию от критических заболеваний',
    [INSURANCE_OFFERS['strahovka-ot-klescha']]: 'по страховке от укуса клеща',
    [BUSINESS_OFFERS.biznesRegistration]: 'по регистрации бизнеса',
    [BUSINESS_OFFERS.biznesRko]: 'по РКО',
    [BUSINESS_OFFERS.biznesKredity]: 'по кредитам для бизнеса',
    [BUSINESS_OFFERS.biznesEkvajring]: 'по эквайрингу',
    [BUSINESS_OFFERS.biznesAccounting]: 'по ведению бухгалтерского учёта',
    [BUSINESS_OFFERS.bankovskieGarantii]: 'по банковским гарантиям',
    // [BUSINESS_OFFERS.biznesDepozit]: 'по вкладам для бизнеса',
    [BUSINESS_OFFERS.biznesMarketplace]: 'по бизнесу на маркетплейсах',
    [BUSINESS_OFFERS.biznesLeasing]: 'по лизингу',
    [BUSINESS_OFFERS.zarplatnyjProekt]: 'по зарплатным проектам',
    [BUSINESS_OFFERS.biznesVed]: 'по ВЭД',
};
const LEARNING_TYPES_TITLES = {
    typeProgramming: 'по программированию',
    typeAnalytics: 'по аналитике',
    typeMarketing: 'по маркетингу',
    typeDesign: 'по дизайну',
    typeManagement: 'по бизнесу и управлению',
    typeAdmin: 'по администрированию',
    typeFinance: 'по финансам',
    typeLanguage: 'по иностранным языкам',
    typeCreativity: 'по творчеству и созданию контента',
    typeSoftSkills: 'по саморазвитию и soft skills',
    typeApplication: 'по рукоделию',
    typeBeauty: 'по красоте и здоровью',
    typePO: 'по прикладным программам',
    typeSport: 'по спорту',
    typeDPO: 'по ДПО',
};

export { LEARNING_TYPES_TITLES, SPECIAL_TAB_TO_TITLE_MAP };
//# sourceMappingURL=titles.js.map
